import { useEffect, useState } from 'react';
import { getPublicPage } from '../../lib/api';
import type { PublicPage } from '../../lib/types';
import { PublicLayout } from '../PublicLayout';

interface ContentPageProps {
  slug: string;
}

export function ContentPage({ slug }: ContentPageProps) {
  const [page, setPage] = useState<PublicPage | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    getPublicPage(slug)
      .then(setPage)
      .catch(() => setError('This page is not available right now.'));
  }, [slug]);

  return (
    <PublicLayout>
      <main className="content-page">
        {error ? <p role="alert">{error}</p> : null}
        {page ? (
          <article>
            <h1>{page.title}</h1>
            <p>{String(page.content.body ?? page.content.lead ?? '')}</p>
          </article>
        ) : null}
      </main>
    </PublicLayout>
  );
}
